import { useCallback } from "react";
import { useMutation } from "react-query";
import ServiceNowAPI from "../ServiceNowAPI";

export const useServiceNowApprovalAction = (config) => {
  const mutationFn = useCallback(
    async ({ approvalSysID, approvalTeamID, action, comments }) => {
      return ServiceNowAPI.postApprovalAction({
        approvalSysID,
        approvalTeamID,
        action,
        comments,
      });
    },
    []
  );

  return useMutation(mutationFn, config);
};
